const getThumbnailPosition = (thumnbsAttr: string, thumbnailEl: Element) : number => parseInt(thumbnailEl.getAttribute(thumnbsAttr))
export default getThumbnailPosition;